import { render, staticRenderFns } from "./AirCulturePage.vue?vue&type=template&id=5840b172&scoped=true&"
import script from "./AirCulturePage.vue?vue&type=script&lang=js&"
export * from "./AirCulturePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5840b172",
  null
  
)

export default component.exports